import React, { Component } from 'react';
import header_icon from '../assets/images/logo.jpg';

class Header extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="header is-hidden-mobile">
                <div className="topbar_left">
                    <img className="header_icon" src={header_icon} alt='escudos fif-uaq'/>
                    <a href="/solicitudes"><h3 className="web_title">Facultad de Informática | Consejo Académico</h3></a>
                </div>
                <div className="topbar_right">
                    <a className="topbar_menu" href="/solicitudes/tramites">Trámites</a>
                    <a className="topbar_menu" href="/solicitudes/seguimiento"><button className="btn btn-rastrear">Rastrear solicitud</button></a>
                </div>
            </div>
        );
    }
}
 
export default Header;